import { Button } from "@progress/kendo-react-buttons";
import React, { useEffect, useState } from "react";
import {
  Chapter as C,
  Chapter,
  CourseModuleCards,
  GenerativeAIRequestChapters,
  GenerativeAiChapters,
} from "@mikros/library";
import { Confirm, GenerateCourseChaptersCards } from "@mikros/shared-ui";
import { FormattedMessage, useIntl } from "react-intl";
import { GenerativeAiRequestCards } from "@mikros/library/src/model";

import {
  Sortable,
  SortableItemUIProps,
  SortableOnDragOverEvent,
  SortableOnNavigateEvent,
} from "@progress/kendo-react-sortable";
import { ChapterData } from "./chapterData";
import { Dialog } from "@progress/kendo-react-dialogs";
import Account from "../../../../utils/apiConfig";
import { Error } from "@progress/kendo-react-labels";

export interface GenerateChaptersProps {
  duplicateS3File: (
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) => void;
  handleUploadGiveUrl: (e: CourseModuleCards) => void;
  handleUpdateStatusRev: (
    status: string,
    course: CourseModuleCards
  ) => Promise<boolean>;
  handleUpdateStatusAll: (
    status: string,
    course?: CourseModuleCards
  ) => Promise<boolean>;
  handleState: () => void;
  chapters: GenerativeAiChapters;
  cards: CourseModuleCards;
  handleAIChapterCardChange: (course: CourseModuleCards) => Promise<boolean>;
  handleRequestCards: (e: GenerativeAiRequestCards, nav?: boolean) => void;
  changeToCardState: boolean;
  handleVideoGeneration?: (e: any) => Promise<string | false>;
  handleImageGeneration?: (e: any) => Promise<string | false>;
  // handleAudioGeneration?:(e:any)=>Promise<string|false>
  handleAudioGeneration?: (e: any) => Promise<{ presignedUrl: string; prompt: string } | false>;
}

export function GenerateChapters(props: GenerateChaptersProps) {
  const intl = useIntl();
  const accountInstance = Account.getInstance();

  const containerRef = React.useRef<HTMLDivElement>(null);

  const [data1, setData] = useState<GenerativeAiChapters>(props.chapters);
  const [chapterDragData, setChapterDragData] = useState<Array<object>>(
    props.chapters.data.Chapters
  );

  const [newDataAdded, setNewDataAdded] = useState<boolean>(false);
  const [nextScreen, setNextScreen] = useState<boolean>(false);
  const [requestingChaptersList, setRequestingChaptersList] = useState<
    string[]
  >(
    props.chapters.data.Chapters.map((chapterData: any) => {
      return chapterData.chapterId;
    })
  );
  const [generateCardDialog, setGenerateCardDialog] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [enableDrag, setEnableDrag] = useState<boolean>(false);
  const [addNewChapterClick, setAddNewChapterClick] = useState<boolean>(false);
  console.log("add new chapter click", addNewChapterClick);
  console.log(
    "requesting chapter list in generate chapters",
    requestingChaptersList
  );
  console.log("chapter drag data", chapterDragData);

  const handleAddNewChapter = () => {
    if (true) {
      let data = { ...data1 };
      data.data.TotalChapters = data.data.TotalChapters + 1;
      let newChapter = {} as C;
      newChapter.chapterId = data.data.TotalChapters.toString();
      newChapter.seqNo = data.data.TotalChapters;
      newChapter.chapterNumber = data.data.TotalChapters;
      newChapter.isLastChapter = false;
      newChapter.entryType = "CHAPTER";
      newChapter.status = "DRAFT";
      newChapter.chapterName = "";
      newChapter.description = "";
      newChapter.recType = "";
      newChapter.updatedAt = "";
      newChapter.courseName = data.data.courseName;
      newChapter.expTime = 100;
      newChapter.entityId = "";
      newChapter.createdAt = "";
      newChapter.date = "";

      data.data.Chapters.push(newChapter);
      setData({ ...data });
      setNewDataAdded(true);
    }
  };
  const onDragOver = (event: SortableOnDragOverEvent) => {
    let data = data1;
    data.data.Chapters = event.newState as Chapter[];
    setChapterDragData(data.data.Chapters);
    setData(data);
  };
  const onNavigate = (event: SortableOnNavigateEvent) => {
    console.log("this is navigate", event.newState);
    let data = data1;
    data.data.Chapters = event.newState as Chapter[];
    setChapterDragData(data.data.Chapters);
    setData(data);
  };

  const handleEnableDrag = (e: boolean) => {
    setEnableDrag(e);
  };

  const handleRequestGenerativeAiCards = (nav: boolean) => {
    console.log("nav value inside handle request generative", nav);
    if (requestingChaptersList.length >= 1) {
      let chapterBody: GenerativeAiRequestCards = {
        accntId: accountInstance.accntId,
        chapterCount: requestingChaptersList.length,
        courseId: data1.courseId!!,
        createdBy: "",
        chapters: [],
      } as GenerativeAiRequestCards;

      for (let chapter of data1.data.Chapters) {
        if (requestingChaptersList.includes(chapter.chapterId)) {
          let chpt: GenerativeAIRequestChapters = {
            cardsCount: Math.floor(Math.random() * 6) + 10,
            chapterId: chapter.chapterId,
            cardsMaxChars: 300,
            cardsMinChars: 100,
            chapterName: chapter.chapterName,
          } as GenerativeAIRequestChapters;
          chapterBody.chapters.push(chpt);
        }
      }

      props.handleRequestCards(chapterBody, nav);
    }
    // else {
    //   let err: any = {};
    //   err.noChapter = {
    //     error: intl.formatMessage({ id: "courses.generateChapters.error" }),
    //   };
    //   setErrors(err);
    // }
  };

  const handleListOfRequestingChapterCards = (chapterId: string) => {
    console.log("inside handle chapter selection ");
    setErrors((prev: any) => ({
      ...prev,
      noChapter: null, //clear the error
    }));
    if (requestingChaptersList.includes(chapterId)) {
      let chptList = requestingChaptersList;
      chptList = chptList.filter((ele) => {
        return ele !== chapterId;
      });
      setRequestingChaptersList(chptList);
    } else {
      let chptList = requestingChaptersList;
      chptList.push(chapterId);
      setRequestingChaptersList(chptList);
    }
  };
  const handleChapters = (e: C) => {
    console.log("inside handle chap");
    let dts = props.chapters;

    let x = props.chapters.data.Chapters.filter((item) => {
      if (item.chapterId === e.chapterId) {
        return item;
      }
    })[0];

    const index = props.chapters.data.Chapters.findIndex(
      (ex) => ex.chapterId === e.chapterId
    );

    x.description = e.description;
    x.chapterName = e.chapterName;
    dts.data.Chapters[index] = x;
    setData(dts);
  };
  const toggleGenerateCardDialog = () => {
    if (requestingChaptersList.length < 1) {
      let err: any = {};
      err.noChapter = {
        error: intl.formatMessage({ id: "courses.generateChapters.error" }),
      };
      setErrors(err);
    } else {
      setGenerateCardDialog(!generateCardDialog);
    }
  };

  useEffect(() => {
    setNextScreen(props.changeToCardState);
  }, [props.changeToCardState]);

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div>
      {generateCardDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={`${intl.formatMessage({
              id: "courses.generateChapters.chapterGenMessage",
            })}`}
            successText={`${intl.formatMessage({
              id: "chapter.success",
            })}`}
            failureText={`${intl.formatMessage({
              id: "chapter.failure",
            })}`}
            cancelText={`${intl.formatMessage({
              id: "cancelButton",
            })}`}
            onCancel={() => {
              toggleGenerateCardDialog();
            }}
            backgroundColor={"mk-orange"}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgAlert",
            })}`}
            onSuccess={() => {
              toggleGenerateCardDialog();
              handleRequestGenerativeAiCards(true);
            }}
            onFailure={() => {
              toggleGenerateCardDialog();
              handleRequestGenerativeAiCards(false);
            }}
          />
        </Dialog>
      )}
      {nextScreen === false ? (
        <div className="flex flex-col space-y-4">
          <div className="w-full flex items-center justify-end">
            <Button
              themeColor={"primary"}
              onClick={() => {
                setAddNewChapterClick(true);
                handleAddNewChapter();
              }}
            >
              <FormattedMessage id="courses.generativeAi.generatedChapters.AddChapterButton" />
            </Button>
          </div>

          <div>
            {errors.noChapter?.error && <Error>{errors.noChapter.error}</Error>}
          </div>

          <div className="w-full">
            <Sortable
              className="flex flex-col w-full"
              idField={"chapterId"}
              disabledField={"disabled"}
              data={chapterDragData}
              itemUI={(e: SortableItemUIProps) => {
                let props: any = {
                  ...e,
                  handleChecked(chapterId: string) {
                    handleListOfRequestingChapterCards(chapterId);
                  },
                  reqListChapters: requestingChaptersList,
                  enableDrag: enableDrag,
                  handleChapterUpd(chpt: C) {
                    handleChapters(chpt);
                  },
                  handleEnableDrag(enableDisable: boolean) {
                    handleEnableDrag(enableDisable);
                  },
                };
                return ChapterData(props);
              }}
              onNavigate={onNavigate}
              onDragOver={onDragOver}
            />
            <div ref={containerRef} />
          </div>
          <div className="w-full flex justify-end items-center">
            <Button
              themeColor="primary"
              disabled={true}
              onClick={() => props.handleState()}
              className="mr-12"
            >
              <FormattedMessage id="backButton" />
            </Button>
            <Button
              themeColor="primary"
              // onClick={() => handleRequestGenerativeAiCards()}
              onClick={() => toggleGenerateCardDialog()}
            >
              <FormattedMessage id="generateCardsButton" />
            </Button>
          </div>
        </div>
      ) : (
        <GenerateCourseChaptersCards
          isManual={false}
          duplicateS3File={(
            sourceKey: string,
            destinationKey: string,
            fileType: string
          ) => {
            return props.duplicateS3File(sourceKey, destinationKey, fileType);
          }}
          specificCreateCourseFunction={(
            course: CourseModuleCards
          ): Promise<boolean> => {
            console.log("this is the updated course", course);
            return props.handleAIChapterCardChange(course);
          }}
          cards={props.cards}
          handleUploadGiveUrl={(e: CourseModuleCards) => {
            return props.handleUploadGiveUrl(e);
          }}
          tenantRole={accountInstance.accntRole}
          handleUpdateStatusRev={(
            status: string,
            course: CourseModuleCards
          ): Promise<boolean> => {
            return props.handleUpdateStatusRev(status, course);
          }}
          handleUpdateStatusAll={(
            status: string,
            course: CourseModuleCards
          ): Promise<boolean> => {
            return props.handleUpdateStatusAll(status, course);
          }}
          handleVideoGeneration={(e: any) => {
            console.log("calling handle video generation", e);
            if (props.handleVideoGeneration) {
              return props.handleVideoGeneration(e);
            }
            return Promise.resolve(false);
          }}
          handleImageGeneration={(e: any) => {
            console.log("calling handle image generation", e);
            if (props.handleImageGeneration) {
              return props.handleImageGeneration(e);
            }
            return Promise.resolve(false);
          }}
          // handleAudioGeneration = {(e:any)=>{
          //   console.log("calling handle audio generation",e)
          //   if(props.handleAudioGeneration)
          //   {
          //     return props.handleAudioGeneration(e);
          //   }
          //   return Promise.resolve(false)
          // }}

          handleAudioGeneration={(e: any): Promise<{ presignedUrl: string; prompt: string } | false> => {
            console.log("Calling handle audio generation ", e);
            if (props.handleAudioGeneration) {
              return props.handleAudioGeneration(e);
            }
            return Promise.resolve(false);
          }}
        />
      )}
    </div>
  );
}
